import { resolveResearchTopicTemplate } from "~/helpers/resolveResearchTopicTemplate";
import { ResearchTopicTemplate } from "~/types/app";

export const useResearchTopicTemplate = (): ResearchTopicTemplate => {
  const { researchTopicTemplate } = useRuntimeConfig().public;
  return resolveResearchTopicTemplate(researchTopicTemplate);
};

export const useResearchTopicSectionTitleClass = (): string => {
  return useResearchTopicTemplate() === ResearchTopicTemplate.V2
    ? "SectionTitle"
    : "Section__title";
};
